import { createSelector } from 'reselect';

const serverError = (state: any) => state.errorReducer.error;

export const getServerError = createSelector(serverError, (state) => state);
